import axios from "axios"
import { IKiz2DocumentGetDTO } from "../../coreapi-dto/dirs/kiz";
import { IMovementGetDTO } from "../../coreapi-dto/documents/movement";
import { IMovementItemEditDTO, IMovementItemGetDTO } from "../../coreapi-dto/documents/movementItem";
import { envF } from "../../../env";

export const getMovementItemUpdateDTO = async (idDocument: string, callback: (e) => void) => {

    const jwtToken = localStorage.getItem("TokenData") as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
    const header = {
        headers: {
            Authorization: token
        },
    }

    const generateKizRequestUrl = (idDocumentItem) => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/Kiz/Document/${idDocument}/Item/${idDocumentItem}`
    }

    const generateMovementRequestUrl = () => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/Movement/${idDocument}`
    }

    let movement = await axios.get<IMovementGetDTO>(
        generateMovementRequestUrl(),
        header
    )

    let items: IMovementItemEditDTO[] = []

    const itemsPush = async (x: IMovementItemGetDTO) => {
        if (!x.isKiz) {
            items.push({
                idGlobal: x.idGlobal as string,
                idGoodsGlobal: x.goods.idGlobal,
                idScalingRatioGlobal: x.scalingRatio.idGlobal,
                idLotFromGlobal: x.lotFrom.idGlobal,
                idTaxTypeGlobal: x.taxType?.idGlobal,
                supplierCostInfo: x.supplierCostInfo,
                retailCostInfo: x.retailCostInfo,
                producerPrice: x.producerPrice,
                gosContractName: x.gosContractName,
                idGosContractGoodsGlobal: x.gosContractGoods?.idGlobal,
                isKiz: x.isKiz,
                actualQuantity: x.actualQuantity,
                quantity: x.quantity,
                goodsCode: x.goodsCode,
                producer: x.producer,
                denominator: x.denominator,
                numerator: x.numerator,
                supplierFrom: x.supplierFrom,
                supplierTo: x?.supplierTo,
                supplier: x.supplier,
                dateCreated: x.dateCreated,
                isOsu: x.kizOsuDto?.barcode !== undefined,
                kizOsuDto: x.kizOsuDto,
                gtin: x.gtin,
                isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                financialSecurity: x?.financialSecurity
            })
        } else {
            await axios.get<IKiz2DocumentGetDTO>(
                generateKizRequestUrl(x.idGlobal),
                header
            ).then((e) => {
                items.push({
                    idGlobal: x.idGlobal as string,
                    idGoodsGlobal: x.goods.idGlobal,
                    idScalingRatioGlobal: x.scalingRatio.idGlobal,
                    idLotFromGlobal: x.lotFrom.idGlobal,
                    idTaxTypeGlobal: x.taxType?.idGlobal,
                    supplierCostInfo: x.supplierCostInfo,
                    retailCostInfo: x.retailCostInfo,
                    producerPrice: x.producerPrice,
                    idGosContractGoodsGlobal: x.gosContractGoods?.idGlobal,
                    isKiz: x.isKiz,
                    gosContractName: x.gosContractName,
                    goodsCode: x.goodsCode,
                    producer: x.producer,
                    actualQuantity: x.actualQuantity,
                    quantity: x.quantity,
                    kizs: e.data.items[0].kizes ?? [],
                    kizBoxes: e.data.items[0].kizBoxes ?? [],
                    kizOsuDtos: e.data.items[0].kizOsuDtos ?? [],
                    denominator: x.denominator,
                    numerator: x.numerator,
                    supplierFrom: x.supplierFrom,
                    supplierTo: x?.supplierTo,
                    supplier: x.supplier,
                    dateCreated: x.dateCreated,
                    isOsu: x.kizOsuDto?.barcode !== undefined,
                    kizOsuDto: x.kizOsuDto,
                    gtin: x.gtin,
                    isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                    financialSecurity: x?.financialSecurity
                })
            }).catch(() => {
                items.push({
                    idGlobal: x.idGlobal as string,
                    idGoodsGlobal: x.goods.idGlobal,
                    idScalingRatioGlobal: x.scalingRatio.idGlobal,
                    idLotFromGlobal: x.lotFrom.idGlobal,
                    idTaxTypeGlobal: x.taxType?.idGlobal,
                    supplierCostInfo: x.supplierCostInfo,
                    retailCostInfo: x.retailCostInfo,
                    producerPrice: x.producerPrice,
                    idGosContractGoodsGlobal: x.gosContractGoods?.idGlobal,
                    isKiz: x.isKiz,
                    actualQuantity: x.actualQuantity,
                    quantity: x.quantity,
                    goodsCode: x.goodsCode,
                    producer: x.producer,
                    gosContractName: x.gosContractName,
                    kizs: [],
                    kizBoxes: [],
                    kizOsuDtos: [],
                    denominator: x.denominator,
                    numerator: x.numerator,
                    supplierFrom: x.supplierFrom,
                    supplierTo: x?.supplierTo,
                    supplier: x.supplier,
                    dateCreated: x.dateCreated,
                    isOsu: x.kizOsuDto?.barcode !== undefined,
                    kizOsuDto: x.kizOsuDto,
                    gtin: x.gtin,
                    isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                    financialSecurity: x?.financialSecurity
                })
            })
        }
    }

    const addItems = async () => {
        const unresolvedPromises = movement.data.items.map((x) => itemsPush(x));
        await Promise.all(unresolvedPromises);
    }

    addItems().then(() => callback(items))

}


